import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { SiteMetadata } from 'components'
import { SITE_METADATA } from 'config'

const propTypes = {
  children: PropTypes.node.isRequired,
  isTrialMembershipsActive: PropTypes.bool,
  promoCodeIsTrial: PropTypes.bool,
}

function Layout({ children, isTrialMembershipsActive, promoCodeIsTrial }) {
  const { metaTitle, description } = SITE_METADATA.MEMBERS_JOIN
  const isTrialMembership = isTrialMembershipsActive && promoCodeIsTrial

  return (
    <>
      <SiteMetadata metaTitle={metaTitle} description={description} />
      <div className="image-and-form-layout purchase-flow">
        <div className="split-image-block">
          <img
            src={
              isTrialMembership
                ? '/assets/images/imagery/purchase-flow/trial-boat.png'
                : '/assets/images/imagery/purchase-flow/boat.png'
            }
            alt=""
          />
        </div>
        {children}
      </div>
    </>
  )
}

Layout.propTypes = propTypes

function mapStateToProps(state) {
  return {
    isTrialMembershipsActive: memberSelectors.isTrialMembershipsActive(state),
    promoCodeIsTrial: memberSelectors.promoCodeIsTrial(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  Layout,
)
